export const customReceivableCells =
  [
    {
      slotName: 'amount',
      value: 'amount'
    },
    {
      slotName: 'weight',
      value: 'weight'
    },
    {
      slotName: 'volume',
      value: 'volume'
    },
    {
      slotName: 'product',
      value: 'product'
    },
    {
      slotName: 'actions',
      value: 'actions'
    },
    {
      slotName: 'base-cost-rate',
      value: 'baseCost.rate'
    }
  ]

export const customCorrectionCells =
  [
    {
      slotName: 'activity',
      value: 'activity'
    },
    {
      slotName: 'net-weight',
      value: 'netWeight'
    },
    {
      slotName: 'amount',
      value: 'amount'
    }
  ]
